import { render, staticRenderFns } from "./Shell.vue?vue&type=template&id=166b2f55&"
import script from "./Shell.vue?vue&type=script&lang=ts&"
export * from "./Shell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('166b2f55')) {
      api.createRecord('166b2f55', component.options)
    } else {
      api.reload('166b2f55', component.options)
    }
    module.hot.accept("./Shell.vue?vue&type=template&id=166b2f55&", function () {
      api.rerender('166b2f55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-viz/Shell.vue"
export default component.exports